import styled, { css } from 'styled-components'

export default styled.div`
  position: flex;

  a {
    direction: ltr !important;
  }
`



// WEBPACK FOOTER //
// ./src/components/SubNav.js